export const BAT_EMPLOYEE_ROLE = 'bat_employee';

export const isBatEmployee = (userOrRole) => {
  const role =
    typeof userOrRole === 'string' ? userOrRole : userOrRole?.role || null;
  return String(role || '').toLowerCase() === BAT_EMPLOYEE_ROLE;
};
